import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components'
import {Button} from 'rebass'
import BaseModal from './BaseModal'

const StyledDefaultButton = styled(Button)``

StyledDefaultButton.defaultProps = {
	variant: 'main'
};

const DefaultOpenComponent = (props) => (
	<Button variant={'main'} {...props}>Add New</Button>
)


const PopupForm = (props) => {
	const { FormComponent, ShowComponent, handleSubmit, initialValues} = props;

	return (
		<div>
			<BaseModal
				isForm={true}
				hideButtons={true}
				OpenButton={ShowComponent}
				FormComponent={FormComponent}
				handleSubmit={handleSubmit}
				initialValues={initialValues}
			/>
		</div>
	);
};


PopupForm.propTypes = {
	handleConfirm: PropTypes.func,
	handleSubmit: PropTypes.func,
	toggle: PropTypes.func,
	visible: PropTypes.bool,
	FormComponent: PropTypes.func,
	ShowComponent: PropTypes.func,
	initialValues: PropTypes.object,
	title: PropTypes.string
};

PopupForm.defaultProps = {
	handleConfirm: () => console.log('clicked confirm delete'),
	handleSubmit: (values) => console.log('values'),
	visible: false,
	title: "New Item",
	ShowComponent: DefaultOpenComponent
};

export default PopupForm;
